import { render, staticRenderFns } from "./StudentFormInformation.vue?vue&type=template&id=46083569&scoped=true&"
import script from "./StudentFormInformation.vue?vue&type=script&lang=ts&"
export * from "./StudentFormInformation.vue?vue&type=script&lang=ts&"
import style0 from "./StudentFormInformation.vue?vue&type=style&index=0&id=46083569&lang=scss&scoped=true&"
import style1 from "./StudentFormInformation.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./StudentFormInformation.vue?vue&type=style&index=2&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46083569",
  null
  
)

export default component.exports